import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
import {
  FiCalendar,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
} from "react-icons/fi";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
function EditReservation() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isReservationAccordionOpen, setIsReservationAccordionOpen] =
    useState(true);
  const toggleReservationAccordion = () =>
    setIsReservationAccordionOpen((o) => !o);
  const [isDossierAccordionOpen, setIsDossierAccordionOpen] = useState(true);
  const toggleDossierAccordion = () => setIsDossierAccordionOpen((o) => !o);
  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [reservationsData, setReservationsData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/statuts_reservations?id=${id}&natures_investissement_id=${selectedCategorie?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setStatutData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/reservations/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const reservationsData = await response.json();
      setReservationsData(reservationsData);
      console.log(reservationsData);
      setSelectedPartenaire(
        reservationsData?.detail_reservation?.Réservation?.Partenaire
      );
      setSelectedInvestisseur(
        reservationsData?.detail_reservation?.Réservation?.Investisseur
      );
      setSelectedStatut(
        reservationsData?.detail_reservation?.Réservation?.Statut
      );
      setSelectedCategorie(
        reservationsData?.detail_reservation?.Réservation?.["Catégorie PME"]
      );
      setSelectedPme(
        reservationsData?.detail_reservation?.Réservation?.["PME (si connue)"]
      );
      setSelectedAnnee(
        reservationsData?.detail_reservation?.Réservation?.[
          "Année de souscription"
        ]
      );
      setSelectedTaux(
        reservationsData?.detail_reservation?.Réservation?.["Taux d'apport"]
      );
      setSelectedDateEngagement(
        reservationsData?.detail_reservation?.Réservation?.[
          "Date engagement ferme"
        ]
      );
      setSelectedDateLimite(
        reservationsData?.detail_reservation?.Réservation?.[
          "Date limite de confirmation"
        ]
      );
      setSelectedMontant(
        reservationsData?.detail_reservation?.Réservation?.["Montant (€)"]
      );
      setSelectedComplement(
        reservationsData?.detail_reservation?.Réservation?.[
          "Complément d'informations"
        ]
      );
      setSelectedDateSignature(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Date de signature"
        ]
      );
      setSelectedMode(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Mode de règlement"
        ]
      );
      setSelectedIban(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "IBAN"
        ]
      );
      setSelectedBic(
        reservationsData?.detail_reservation?.["Dossier de souscription"]["BIC"]
      );
      setSelectedRum(
        reservationsData?.detail_reservation?.["Dossier de souscription"]["RUM"]
      );
      setSelectedDatePrelevement(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Date de prélèvement"
        ]
      );
      setSelectedLieuSignature(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Lieu de signature"
        ]
      );
    } catch (error) {
      console.error(error);
    }
  };
  /************************* Partenaire *******************************/
  const [partenairesData, setPartenairesData] = useState({ data: [] });
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/partenaires?id=${id}&investisseur_id=${selectedInvestisseur?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setPartenairesData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenairesData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Partenaire *******************************/
  /*************************   Investisseurs  *******************************/
  const [investisseursData, setInvestisseursData] = useState({ data: [] });
  const [selectedInvestisseur, setSelectedInvestisseur] = useState("");
  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const getInvestisseurs = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/investisseurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setInvestisseursData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseursOptions = () => {
    return [
      {
        options: investisseursData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Investisseurs *******************************/
  /*************************   Catégorie PME  *******************************/
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const [categorieData, setCategorieData] = useState({ data: [] });
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  console.log(selectedCategorie);
  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((categorie) => {
          setCategorieData(categorie);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/pmes?id=${id}&natures_investissement_id=${selectedCategorie?.value}&pme_id=${selectedPme?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Année   *******************************/
  const [selectedAnnee, setSelectedAnnee] = useState("");
  const [anneeData, setAnneeData] = useState({ data: [] });
  const handleAnneeChange = (e) => {
    setSelectedAnnee(e);
  };
  const getAnnee = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/annees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setAnneeData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAnneeOptions = () => {
    return [
      {
        options: anneeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Année *******************************/
  /*************************   Taux d'apport  *******************************/
  const [selectedTaux, setSelectedTaux] = useState("");
  const [tauxData, setSelectedTauxData] = useState({ data: [] });
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/taux_apports?id=${id}&investisseur_id=${selectedInvestisseur?.value}&taux_apport_id=${selectedTaux.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Montant *******************************/
  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };

  /*************************   END Montant  *******************************/
  /*************************   Date d'engagement et limite *******************************/
  const [selectedDateEngagement, setSelectedDateEngagement] = useState("");
  const [selectedDateLimite, setSelectedDateLimite] = useState("");

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedComplement, setSelectedComplement] = useState("");
  const handleComplementChange = (e) => {
    setSelectedComplement(e.target.value);
  };
  /************************* END Complément   *******************************/

  /******************************* Date de signature *******************************************/
  const [selectedDateSignature, setSelectedDateSignature] = useState("");
  /******************************* END date de signature *******************************************/
  /******************************* Lieu de signature *******************************************/
  const [selectedLieuSignature, setSelectedLieuSignature] = useState("");
  const handleLieuChange = (e) => {
    setSelectedLieuSignature(e.target.value);
  };
  /******************************* END Lieu *******************************************/
  /******************************* Mode de règlement *******************************************/
  const [selectedMode, setSelectedMode] = useState("");
  const [modeData, setModeData] = useState({ data: [] });
  const handleModeChange = (e) => {
    setSelectedMode(e);
  };

  const getMode = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations/mode_reglements?id=${id}&mode_reglement_id=${selectedMode?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setModeData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeOptions = () => {
    return [
      {
        options: modeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Mode de règlement *******************************************/
  /******************************* IBAN *******************************************/
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  /******************************* END IBAN *******************************************/
  /******************************* BIC *******************************************/
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /******************************* END BIC *******************************************/
  /******************************* RUM *******************************************/
  const [selectedRum, setSelectedRum] = useState("");
  const handleRumChange = (e) => {
    setSelectedRum(e.target.value);
  };
  /******************************* END RUM *******************************************/
  /******************************* Date prelevement *******************************************/
  const [selectedDatePrelevement, setSelectedDatePrelevement] = useState("");
  const handleDatePrelevementChange = (e) => {
    setSelectedDatePrelevement(e.target.value);
  };
  /******************************* END Date prelevement *******************************************/
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedPartenaire === null &&
      selectedStatut === null &&
      selectedTaux === null &&
      selectedAnnee === null
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else if (selectedPartenaire === null && selectedStatut === null) {
      toast.error("Le statut et le partenaire ne peuvent pas être vide");
    } else if (selectedTaux === null) {
      toast.error("Le taux ne peut pas être vide");
    } else if (selectedAnnee === null) {
      toast.error("L'année ne peut pas être vide");
    } else if (selectedPartenaire === null) {
      toast.error("Le partenaire ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/reservations/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              reservation: {
                id: id,
                partenaire_id: selectedPartenaire?.value || "",
                investisseur_id: selectedInvestisseur?.value || "",
                natures_investissement_id: selectedCategorie?.value || "",
                montant: selectedMontant,
                statuts_reservation_id: selectedStatut?.value || "",
                date_limite_confirmation: selectedDateLimite,
                date_engagement_ferme: selectedDateEngagement,
                taux_apport_id: selectedTaux?.value || "",
                pme_id: selectedPme?.value || "",
                annee_id: selectedAnnee?.value || "",
                complement_dinformations: selectedComplement,
                lieu_de_signature: selectedLieuSignature,
                date_de_signature: selectedDateSignature,
                mode_reglement_id: selectedMode?.value || "",
                iban: selectedIban,
                bic: selectedBic,
                rum: selectedRum,
                date_prelevement: selectedDatePrelevement,
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          const responseData = await response.json();
          // localStorage.setItem("key", true);
          // localStorage.setItem("lastId", id);

          navigate(`${backUrl}${responseData.go_to}`);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.reservation_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors = responseData?.reservation_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  useEffect(() => {
    if (!loading) {
      getMode();
      getPartenaire();
      getStatut();
      getTaux();
      getAnnee();
      getInvestisseurs();
      getPme();
      getCategories();
    }
  }, [loading]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Réservations | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    console.log(selectedMode);
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails réservation
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/reservations/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Réservations
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          reservationsData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleReservationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Réservation
                                      </span>
                                    </div>
                                    {isReservationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  {/* Contenu repliable */}
                                  <Collapse isOpen={isReservationAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(
                                          reservationsData?.detail_reservation
                                            ?.Réservation || {}
                                        ).map(([key, value], index) => {
                                          const isRequired =
                                            key === "Statut" ||
                                            key === "Partenaire" ||
                                            key === "Année de souscription" ||
                                            key === "Taux d'apport";

                                          return (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft: isRequired
                                                  ? "3px solid #dc3545"
                                                  : "3px solid transparent",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                if (isRequired) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  isRequired
                                                    ? "#dc3545"
                                                    : "transparent";
                                              }}
                                            >
                                              {/* Séparateur subtil */}
                                              {index > 0 && (
                                                <div
                                                  className="field-separator"
                                                  style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    left: "0",
                                                    right: "66%",
                                                    height: "1px",
                                                    background:
                                                      "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                  }}
                                                />
                                              )}

                                              <Row className="align-items-center g-1">
                                                {/* Label */}
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  className="field-label"
                                                >
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      {key}
                                                      {/* {isRequired && "*"} */}
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>

                                                {/* Valeur / champs */}
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  className="field-input"
                                                >
                                                  {/* Selects */}
                                                  {key === "Statut" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedStatut?.label ==
                                                          null
                                                            ? null
                                                            : selectedStatut
                                                        }
                                                        onChange={
                                                          handleStatutChange
                                                        }
                                                        options={renderStatutOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedStatut ===
                                                            null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un statut..."
                                                      />
                                                      {selectedStatut ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Statut ne peut pas
                                                          être vide
                                                        </div>
                                                      )}
                                                    </div>
                                                  ) : key === "Partenaire" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedPartenaire?.label ==
                                                          null
                                                            ? null
                                                            : selectedPartenaire
                                                        }
                                                        onChange={
                                                          handlePartenaireChange
                                                        }
                                                        options={renderPartenaireOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedPartenaire ===
                                                            null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un partenaire..."
                                                      />
                                                      {selectedPartenaire ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Partenaire ne peut pas
                                                          être vide
                                                        </div>
                                                      )}
                                                    </div>
                                                  ) : key ===
                                                    "Catégorie PME" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedCategorie?.label ==
                                                          null
                                                            ? null
                                                            : selectedCategorie
                                                        }
                                                        onChange={
                                                          handleCategorieChange
                                                        }
                                                        options={renderCategorieOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner une catégorie..."
                                                      />
                                                    </div>
                                                  ) : key ===
                                                    "PME (si connue)" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedPme?.label ==
                                                          null
                                                            ? null
                                                            : selectedPme
                                                        }
                                                        onChange={
                                                          handlePmeChange
                                                        }
                                                        options={renderPmeOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner une PME..."
                                                      />
                                                    </div>
                                                  ) : key === "Investisseur" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedInvestisseur?.label ==
                                                          null
                                                            ? null
                                                            : selectedInvestisseur
                                                        }
                                                        onChange={
                                                          handleInvestisseurChange
                                                        }
                                                        options={renderInvestisseursOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un investisseur..."
                                                      />
                                                    </div>
                                                  ) : key ===
                                                    "Année de souscription" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedAnnee?.label ==
                                                          null
                                                            ? null
                                                            : selectedAnnee
                                                        }
                                                        onChange={
                                                          handleAnneeChange
                                                        }
                                                        options={renderAnneeOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner une année..."
                                                      />
                                                      {selectedAnnee ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Année de souscription
                                                          ne peut pas être vide
                                                        </div>
                                                      )}
                                                    </div>
                                                  ) : key ===
                                                    "Taux d'apport" ? (
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          selectedTaux?.label ==
                                                          null
                                                            ? null
                                                            : selectedTaux
                                                        }
                                                        onChange={
                                                          handleTauxChange
                                                        }
                                                        options={renderTauxOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedTaux === null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un taux..."
                                                      />
                                                      {selectedTaux ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Taux d'apport ne peut
                                                          pas être vide
                                                        </div>
                                                      )}
                                                    </div>
                                                  ) : /* Montant */ key ===
                                                    "Montant (€)" ? (
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedMontant
                                                          .toLocaleString(
                                                            "fr-FR",
                                                            {
                                                              style: "currency",
                                                              currency: "EUR",
                                                            }
                                                          )
                                                          .replace("€", "")}
                                                        required
                                                        onChange={
                                                          handleMontantChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  ) : /* Dates */ key ===
                                                    "Date engagement ferme" ? (
                                                    <div className="input-wrapper position-relative">
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={
                                                          selectedDateEngagement
                                                        }
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={(
                                                          dateString
                                                        ) =>
                                                          setSelectedDateEngagement(
                                                            dateString.target
                                                              .value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  ) : key ===
                                                    "Date limite de confirmation" ? (
                                                    <div className="input-wrapper position-relative">
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={
                                                          selectedDateLimite
                                                        }
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={(
                                                          dateString
                                                        ) =>
                                                          setSelectedDateLimite(
                                                            dateString.target
                                                              .value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  ) : /* Complément d'informations */ key ===
                                                    "Complément d'informations" ? (
                                                    <div className="textarea-wrapper position-relative">
                                                      <textarea
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedComplement ||
                                                          ""
                                                        }
                                                        style={{
                                                          width: "100%",
                                                          resize: "vertical",
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.5rem 0.75rem",
                                                          minHeight: "70px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onChange={
                                                          handleComplementChange
                                                        }
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  ) : null}
                                                </Col>
                                              </Row>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Col sm="12">
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En‑tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleDossierAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Dossier de souscription
                                        </span>
                                      </div>
                                      {isDossierAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    {/* Contenu repliable */}
                                    <Collapse isOpen={isDossierAccordionOpen}>
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            reservationsData
                                              ?.detail_reservation?.[
                                              "Dossier de souscription"
                                            ] || {}
                                          ).map(([key], index) => {
                                            const showIBAN =
                                              key === "IBAN" &&
                                              selectedMode?.value === 3;
                                            const showBIC =
                                              key === "BIC" &&
                                              selectedMode?.value === 3;
                                            const showDatePrelevement =
                                              key === "Date de prélèvement" &&
                                              selectedMode?.value === 3 &&
                                              selectedStatut?.value === 6;

                                            const isRequired = key === "";

                                            if (
                                              !(
                                                showIBAN ||
                                                showBIC ||
                                                showDatePrelevement ||
                                                [
                                                  "Lieu de signature",
                                                  "RUM",
                                                  "Mode de règlement",
                                                  "Date de signature",
                                                ].includes(key)
                                              )
                                            ) {
                                              return null;
                                            }

                                            return (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft: isRequired
                                                    ? "3px solid #dc3545"
                                                    : "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  if (isRequired) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    isRequired
                                                      ? "#dc3545"
                                                      : "transparent";
                                                }}
                                              >
                                                {index > 0 && (
                                                  <div
                                                    className="field-separator"
                                                    style={{
                                                      position: "absolute",
                                                      top: "0",
                                                      left: "0",
                                                      right: "66%",
                                                      height: "1px",
                                                      background:
                                                        "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                    }}
                                                  />
                                                )}

                                                <Row className="align-items-center g-1">
                                                  {/* Label */}
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>

                                                  {/* Valeur / champ */}
                                                  <Col xs={12} md={8}>
                                                    {showIBAN ? (
                                                      <div className="input-wrapper position-relative">
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={selectedIban}
                                                          required
                                                          onChange={
                                                            handleIbanChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                            textAlign: "right",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    ) : showBIC ? (
                                                      <div className="input-wrapper position-relative">
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={selectedBic}
                                                          required
                                                          onChange={
                                                            handleBicChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                            textAlign: "right",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    ) : key === "RUM" ? (
                                                      <div className="input-wrapper position-relative">
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={selectedRum}
                                                          required
                                                          onChange={
                                                            handleRumChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                            textAlign: "right",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    ) : key ===
                                                      "Mode de règlement" ? (
                                                      <div className="select-wrapper">
                                                        <Select
                                                          value={
                                                            selectedMode?.label ==
                                                            null
                                                              ? null
                                                              : selectedMode
                                                          }
                                                          onChange={
                                                            handleModeChange
                                                          }
                                                          options={renderModeOptions()}
                                                          isClearable={true}
                                                          classNamePrefix="select2-selection"
                                                          styles={styles(
                                                            selectedMode ===
                                                              null
                                                          )}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                          placeholder="Sélectionner un mode..."
                                                        />
                                                        {selectedMode ===
                                                          null && (
                                                          <div className="invalid-feedback d-block mt-1 small">
                                                            Mode de règlement ne
                                                            peut pas être vide
                                                          </div>
                                                        )}
                                                      </div>
                                                    ) : key ===
                                                      "Lieu de signature" ? (
                                                      <div className="input-wrapper position-relative">
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            selectedLieuSignature
                                                          }
                                                          required
                                                          onChange={
                                                            handleLieuChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                            textAlign: "right",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    ) : key ===
                                                      "Date de signature" ? (
                                                      <div className="input-wrapper position-relative">
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={
                                                            selectedDateSignature
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          onChange={(
                                                            dateString
                                                          ) =>
                                                            setSelectedDateSignature(
                                                              dateString.target
                                                                .value
                                                            )
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                            textAlign: "right",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    ) : null}
                                                  </Col>
                                                </Row>
                                              </div>
                                            );
                                          })}

                                          {/* Date de prélèvement ajoutée si absente */}
                                          {Object.keys(
                                            reservationsData
                                              ?.detail_reservation?.[
                                              "Dossier de souscription"
                                            ] || {}
                                          ).includes("Date de prélèvement") ===
                                            false &&
                                            selectedMode?.value === 3 && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1 mb-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Date de prélèvement
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={
                                                          selectedDatePrelevement
                                                        }
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={
                                                          handleDatePrelevementChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                          {/* IBAN/BIC ajoutés si absents */}
                                          {Object.keys(
                                            reservationsData
                                              ?.detail_reservation?.[
                                              "Dossier de souscription"
                                            ] || {}
                                          ).includes("IBAN") === false &&
                                            selectedMode?.value === 3 && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1 mb-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        IBAN
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative mb-1">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedIban}
                                                        required
                                                        onChange={
                                                          handleIbanChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>

                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        BIC
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedBic}
                                                        required
                                                        onChange={
                                                          handleBicChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                </Col>
                                <IdentificationCard
                                  title="Cumuls"
                                  details={
                                    reservationsData?.detail_reservation?.Cumuls
                                  }
                                />
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditReservation;
